import BaseBehavior from '../../../framework/base/base';

export default class CountDown extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		const { startdate, starttime } = element.dataset;
		this.timerData = { startdate: startdate.replace(/-/g, '/'), starttime };
		this.textMigrationContainer = document.querySelector('.count-down--complete');
		this.textContainer = document.querySelector('.count-down--before');
		this.initializeTimer();
	}

	getTimeRemaining(startTimestamp) {
		const now = new Date();
		// since getTimezoneOffset returns the difference(in minutes) between UTC time and local time, so we are adding it to local time to get utc time
		const nowUtc = now.getTime() + now.getTimezoneOffset() * 60000;
		const t = startTimestamp - nowUtc;

		const seconds = Math.floor((t / 1000) % 60);
		const minutes = Math.floor((t / 1000 / 60) % 60);
		const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
		const days = Math.floor(t / (1000 * 60 * 60 * 24));
		return {
			total: t,
			days,
			hours,
			minutes,
			seconds
		};
	}

	pad2(number) {
		return (number < 10 ? '0' : '') + number;
	}

	initializeTimer() {
		let timerInterval = null;
		let invokeOnce = true;
		const updateClock = () => {
			const startDate = this.timerData.startdate + ' ' + this.timerData.starttime;
			const startTimestamp = new Date(startDate).getTime();
			const t = this.getTimeRemaining(startTimestamp);
			if (t.total <= 0) {
				// hiding countdown after expiration
				this.element.classList.add('v2-hidden');
				// channging text for if counter used in migration
				if (this.element.classList.contains('theme-migration')) {
					if (this.textMigrationContainer) {
						this.textContainer.classList.add('v2-hidden');
						this.textMigrationContainer.classList.remove('v2-hidden');
					}
				}
				if (timerInterval) {
					clearInterval(timerInterval);
				}
				return;
			}
			this.dom.days.innerText = this.pad2(t.days);
			this.dom.hours.innerText = this.pad2(t.hours);
			this.dom.minutes.innerText = this.pad2(t.minutes);
			if (this.dom.seconds) {
				this.dom.seconds.innerText = this.pad2(t.seconds);
			}
			if (invokeOnce) {
				this.element.classList.remove('v2-not-visible');
				invokeOnce = false;
			}
		};

		updateClock(); // to avoid initial delay
		timerInterval = setInterval(updateClock, 1000);
	}
}
